import { gpxService } from 'src/modules/Distances/components/shared/Steps/GPX/services';
import { gpxRouteLoadingStore } from 'src/modules/Distances/components/shared/Steps/GPX/stores';
import { getDistanceId } from 'src/modules/Distances/utils';

export const loadGPX = async () => {
  const distanceId = getDistanceId() || 0;
  gpxRouteLoadingStore.on();
  gpxService.loadGPX(distanceId);
};
